export const KatalogEvidencijaPoPotrebiResourcesEN: KatalogEvidencijaPoPotrebiResourcesBSInterface =
  {
    title: "Evidence as needed",
    errorLoading:
      "An error occurred during loading. Please contact the administrator.",
    placeholder: "Evidence not found.",
  };

// TODO: Translate json
export const JSON_VRSTE_EVIDENCIJE = [
  { value: "TEMPLATE", label: "Template" },
  { value: "EVIDENCIJA", label: "Evidence" },
];

export const JSON_TYPE_EVIDENCIJE = [
  {
    value: "REGULAR",
    label: "Regular",
  },
  { value: "OCCASIONALLY", label: "As needed" },
];

export interface KatalogEvidencijaPoPotrebiResourcesBSInterface {
  title: string;
  errorLoading: string;
  placeholder: string;
}
